/**
 * @fileoverview Ajudas do modal "Compartilhar quadro": a senha forte (sorteio
 * do navegador, nunca Math.random), a validade escolhida em UTC e o tamanho da
 * senha (as regras do servidor, repetidas aqui só para avisar antes).
 */

// Sem os caracteres que se confundem (0/O, 1/l/I): a senha costuma ser ditada.
const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789";
const PASSWORD_LENGTH = 16;

export const PASSWORD_MIN = 8;
const PASSWORD_MAX_BYTES = 72;
const MIN_LIFETIME_MS = 5 * 60 * 1000;
const MAX_LIFETIME_MS = 366 * 24 * 60 * 60 * 1000;
const HOUR_MS = 60 * 60 * 1000;

export const PRESETS = [
  { key: "1h", ms: HOUR_MS },
  { key: "24h", ms: 24 * HOUR_MS },
  { key: "7d", ms: 7 * 24 * HOUR_MS },
  { key: "30d", ms: 30 * 24 * HOUR_MS },
];

/** 16 caracteres sorteados pelo navegador, sem viés (descarta o que sobra do byte). */
export const generateStrongPassword = (cryptoApi = window.crypto) => {
  const limit = 256 - (256 % ALPHABET.length);
  let out = "";
  while (out.length < PASSWORD_LENGTH) {
    const bytes = cryptoApi.getRandomValues(new Uint8Array(PASSWORD_LENGTH * 2));
    for (let i = 0; i < bytes.length && out.length < PASSWORD_LENGTH; i += 1) {
      if (bytes[i] < limit) out += ALPHABET[bytes[i] % ALPHABET.length];
    }
  }
  return out;
};

/** null: senha boa; senão, a chave do aviso (boardShare.form.*). */
export const passwordProblem = (password) => {
  if (String(password || "").trim().length < PASSWORD_MIN) return "passwordTooShort";
  // Bytes em UTF-8 (o limite do bcrypt no servidor), sem depender do TextEncoder.
  if (encodeURIComponent(password).replace(/%[0-9A-F]{2}/gi, "x").length > PASSWORD_MAX_BYTES) return "passwordTooLong";
  return null;
};

/** O valor do campo de data e hora (no fuso do navegador) para o de agora + o prazo. */
export const toLocalInput = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/**
 * A validade escolhida: null = permanente; senão, a data em UTC (ISO). O campo
 * personalizado é lido no fuso do navegador. `invalid` quando a data não serve.
 */
export const resolveExpiration = ({ kind, preset, custom }, now = Date.now()) => {
  if (kind === "permanent") return { expiresAt: null, invalid: false };
  if (preset !== "custom") {
    const found = PRESETS.find((p) => p.key === preset) || PRESETS[1];
    return { expiresAt: new Date(now + found.ms).toISOString(), invalid: false };
  }
  const time = custom ? new Date(custom).getTime() : NaN;
  const invalid = Number.isNaN(time) || time < now + MIN_LIFETIME_MS || time > now + MAX_LIFETIME_MS;
  return { expiresAt: invalid ? null : new Date(time).toISOString(), invalid };
};

export const customBounds = (now = Date.now()) => ({
  min: toLocalInput(new Date(now + MIN_LIFETIME_MS)),
  max: toLocalInput(new Date(now + MAX_LIFETIME_MS)),
});
